import emitAsync from '../utils/emitAsync';
import { usePontosOperacionaisStore } from '../stores/usePontosOperacionaisStore';

let loadingPontosOperacionais = false;

export async function loadPontosOperacionais(socket) {

  if (loadingPontosOperacionais) {
    return false;
  }

  loadingPontosOperacionais = true;

  try {

    const response = await emitAsync(
      socket,
      'pontosOperacionais:get'
    );

    usePontosOperacionaisStore
      .getState()
      .setPontosOperacionais(
        response.data || []
      );

    return true;

  } catch (err) {

    console.error(
      'Erro ao carregar pontos operacionais:',
      err
    );

    return false;

  } finally {

    loadingPontosOperacionais = false;
  }
}